import { render } from "./DeleteTemplateDialog.vue?vue&type=template&id=201dd530"
import script from "./DeleteTemplateDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__